export default __webpack_public_path__ + "static/media/menu6.1810bdcc.webp";